"use client";
import { j as e } from "./index.es44.js";
import { forwardRef as c } from "react";
import { composeClassNames as n } from "./index.es126.js";
import b from "./index.es128.js";
c(
  ({
    label: a,
    type: t = "text",
    value: i,
    placeholder: o,
    onChange: r,
    state: s,
    message: l,
    isDisabled: m,
    ...p
  }, d) => /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs("label", { className: "bl-size-6 bl-display-block", children: [
    a,
    /* @__PURE__ */ e.jsx(
      "input",
      {
        ...p,
        ref: d,
        className: n(
          "bl-input",
          s && `bl-input--${s}`,
          "bl-m-t-1"
        ),
        onChange: r,
        type: t,
        value: i,
        disabled: m,
        placeholder: o
      }
    ),
    l && /* @__PURE__ */ e.jsx("div", { className: "bl-p-t-1", children: /* @__PURE__ */ e.jsx(b, { state: s, children: l }) })
  ] }) })
);
//# sourceMappingURL=index.es48.js.map
